import InsurerEntryTabIcon from '@/common/assets/icons/insurerEntryTab.svg?react';
import CardButton from '@/common/components/cardButton/CardButton';
import useModal from '@/common/hooks/useModal';
import { Box } from 'styled-system/jsx';
import InsurerInformationModal from '@/modules/FileDetail/components/fileInformation/modals/InsurerInformationModal/InsurerInformationModal.tsx';
import { InsurerInformationCardProps } from '@/modules/FileDetail/components/fileInformation/entryTabs/InsurerInformationCard/InsurerInformationCard.types.ts';
const InsurerInformationCard = ({ title }: InsurerInformationCardProps) => {
  const { open, openModal, closeModal } = useModal();

  const renderIcon = () => {
    return <InsurerEntryTabIcon />;
  };

  return (
    <>
      <Box onClick={openModal} mb="16px">
        <CardButton hasArrow renderIcon={renderIcon} title={title} />
      </Box>
      <InsurerInformationModal closeModal={closeModal} open={open} />
    </>
  );
};
export default InsurerInformationCard;
